import { axiosNTL,axiosNT } from '../../../services/axios';
import { TestTemplateBody } from '../types/TestTemplateBody';
import _ from 'lodash';

let list = (params?: any) => {
	const { skip, limit, courseId, testId, testTypeCode ,isMaster,searchQuery, typeId, type } = params
	let queryParams = ''
	if(skip !== undefined && limit !== undefined){
		queryParams += `?skip=${skip}&limit=${limit}` 
	}
	if(courseId){
		queryParams += `&courseId=${courseId}` 
	}
	if(testId){
		queryParams += `&testId=${testId}`
	}
	if(testTypeCode){
		queryParams += `&testTypeCode=${testTypeCode}`
	}
	if(isMaster){
		queryParams += `&isMaster=${isMaster}`
	}
	if(searchQuery){
		queryParams += `&searchQuery=${searchQuery}`
	}
	if(typeId) {
		queryParams += `&typeId=${typeId}`
	}
	if(type) {
		queryParams += `&type=${type}`
	}
	return axiosNTL.get('rule/getRule' + queryParams)
		.then((res: any) => {
			let testList: TestTemplateBody[] = res.responseObject;
			return Promise.resolve(testList);
		});
}

let selectedQuestionsSyllabusList = (reqBody: any) => {
	return axiosNTL.post('question/getQuestionSubjects',reqBody)
		.then((res: any) => {
			let syllabusList: any = res.responseObject;
			return Promise.resolve(syllabusList);
		});
}

export default {
	list,
	selectedQuestionsSyllabusList
};